import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { GeneralService } from 'src/app/services/general/general.service';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';
import { ReplaySubject } from 'rxjs';
import {
  takeUntil,
  distinctUntilChanged,
  pairwise,
  debounceTime,
} from 'rxjs/internal/operators';
import { Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-teacher',
  templateUrl: './teacher.component.html',
  styleUrls: ['./teacher.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeacherComponent implements OnInit, OnDestroy {
  public loading = true;
  public form: FormGroup;
  public currency:any;

  // Availability
  public availabilityRangesOpt = ['0-7', '7-13', '13-20', '20-0'];
  public availabilityDaysOpt: any = [0, 1, 2, 3, 4, 5, 6];
  public availabilityDays: any = [];
  public availabilityRanges: any = [];
  // Price
  public sliderOptions: Options = {
    floor: 5,
    ceil: 100,
    getPointerColor: () => {
      return '#0081c9';
    },
    getSelectionBarColor: () => {
      return '#00edff';
    },
    translate: (value: number): string => {
      return value + '€';
    },
  };
  public sliderMinValue = 5;
  public sliderHighValue = 100;
  // Level
  public levels: any = [];
  // Languages
  public languages: any = [];
  public LangMultiFilterCtrl: FormControl = new FormControl();
  public filteredLangsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  // Country
  public countries = [];
  public countryFilterCtrl: FormControl = new FormControl();
  public filteredCountryMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  // Lessons
  public typeLessons: FormControl = new FormControl('languages');
  public allLessons: any = {};
  public lessons: any = [];
  public lessonFilterCtrl: FormControl = new FormControl();
  public filteredLessons: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  // Order
  public orderOptions: any = [
    {
      label: 'relevance',
      value: 0,
    },
    {
      label: 'price+-',
      value: 1,
    },
    {
      label: 'price-+',
      value: 2,
    },
    {
      label: 'best-grade',
      value: 3,
    },
    {
      label: 'popularity',
      value: 4,
    },
  ];

  public order = new FormControl(this.orderOptions[0].value);

  // Teachers
  public teachers: any = [];
  public loadingTeachersSpinner: any = false;
  public actPage: any = 0;
  public teachersLength: any = 0;

  public subscriptions: any = [];

  public showFilter: any = false;
  public user: any;
  public userInfo: any;

  constructor(
    public general: GeneralService,
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private router: Router
  ) {
    if(!localStorage.getItem("currency")){
      localStorage.setItem('currency', "eur");
    }
    this.currency = localStorage.getItem('currency');

    window.addEventListener('currency_change', () => {
      this.currency = localStorage.getItem('currency');
    }, false);

    this.form = this.formBuilder.group({
      subject: [null],
      search: [''],
      price: [5 + '€ - ' + 100 + '€'],
      country: [null],
      nativeSpiker: [false],
      availability: [''],
      levels: [null],
      languagesTeacher: [null],
    });

  }

  async ngOnInit() {
    try {
      this.loading = true;
      let token = localStorage.getItem('access_token');
      if(token) {
      await this.getUserInfo();
      }

      await this.loadInitalData();
      this.filteredLangsMulti.next(this.languages.slice());
      this.filteredCountryMulti.next(this.countries.slice());
      this.filteredLessons.next(this.lessons.slice());
      this.intializeSubscriptions();

      await this.fillForm();

      await this.filterTeachers(null);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

    
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async loadInitalData() {
    const requests = [
      this.general.httpGet('get-all-lessons'),
      this.general.httpGet('countries'),
      this.general.httpGet('lessons-levels'),
    ];
    const response: any = await this.general.forkJoin(requests);
    const lessonsGroups: any = [];

    this.allLessons = response[0].data;
    this.lessons = response[0].data[this.typeLessons.value];

    this.countries = response[1].data;
    this.levels = response[2].data;
    this.languages = response[0].data.languages.filter(
      (lesson: any) => lesson.type === 'study_lesson'
    );
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.LangMultiFilterCtrl.valueChanges.pipe().subscribe(() => {
        this.filterLangsMulti();
      }),
      this.countryFilterCtrl.valueChanges.pipe().subscribe(() => {
        this.filterCountry();
      }),
      this.lessonFilterCtrl.valueChanges.pipe().subscribe(() => {
        this.filterLesson();
      }),
      this.form.valueChanges
        .pipe(debounceTime(200), pairwise())
        .subscribe((val) => {
          const val1 = JSON.stringify(val[0]);
          const val2 = JSON.stringify(val[1]);
          if (val1 !== val2) {
            if (
              !this.form.value.languagesTeacher &&
              this.form.value.nativeSpiker
            ) {
              this.form.controls.nativeSpiker.patchValue(false);
              return;
            }

            this.filterTeachers(true);
          }
        }),
      this.order.valueChanges.pipe().subscribe((val) => {
        this.filterTeachers(true);
      }),
      this.typeLessons.valueChanges.subscribe((val) => {
        this.lessons = this.allLessons[val];
        this.filteredLessons.next(this.lessons.slice());
        this.form.patchValue({
          subject: this.lessons[0],
        });
      }),
    ];
  }

  async fillForm() {

    let subject = this.lessons[0];
    let params: any = await this.general.getQueryParams();
    //variable para controlar si no ha encontrado resultado de búsqueda, cambie a otra categoría comprobar si lo encuentra
    let new_cat: string = "";
    
    if (params.s && params.cat) {
    let finded: string = "";
    finded = this.allLessons[params.cat].filter(
        (lesson: any) =>
          lesson.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(
              params.s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            ) > -1
      )[0];

      // si venimos de búsqueda libre desde wordiix.com y no ha encontrado resultado para la categoría seleccionada, 
      // hace búsqueda en la otra categoría distinta

      if (!finded) {

        if(params.cat == "languages"){
          new_cat = "subjects";
        }else if(params.cat == "subjects"){
          new_cat = "languages";
        }

        finded = this.allLessons[new_cat].filter(
          (lesson: any) =>
            lesson.name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .indexOf(
                params.s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              ) > -1
        )[0];

        this.router.navigate(['/search/teacher'], {
          queryParams: {
            cat: new_cat,
            s: params.s
          },
        });

      }

      if (finded) {

       if(new_cat){
        //si venimos de recargar por no haber encontrado resultados, actualizamos el formulario con nueva categoría
        this.typeLessons.patchValue(new_cat);
       }else{
        this.typeLessons.patchValue(params.cat);
       }
       
        subject = finded;
        
      } else {
        await this.general.showDanger('lesson-not-found');
      }

    } else if (this.user && this.user.student_lesson_id) {
      Object.keys(this.allLessons).every((key: any) => {
        const finded = this.allLessons[key].find((lesson: any) => {
          return lesson.id === this.user.student_lesson_id;
        });

        if (finded) {
          subject = finded;
          this.typeLessons.patchValue(key);
          return false;
        }

        return true;
      });
    }

    this.form.patchValue({
      subject,
    });
  }

  /**
   * =================== START - Filter ===================
   */
  // Availability
  async onSelectAvailibilityRange(availability: string) {
    // Push or delete
    var index = this.availabilityRanges.indexOf(availability);
    if (index === -1) {
      this.availabilityRanges.push(availability);
    } else {
      this.availabilityRanges.splice(index, 1);
    }
    await this.updateTextAvailabilityFilter();
  }

  async onSelectAvailibilityDay(availability: string) {
    // Push or delete
    var index = this.availabilityDays.indexOf(availability);
    if (index === -1) {
      this.availabilityDays.push(availability);
    } else {
      this.availabilityDays.splice(index, 1);
    }
    await this.updateTextAvailabilityFilter();
  }

  async updateTextAvailabilityFilter() {
    let translations = await this.general.getTranslations(
      this.availabilityDaysOpt.map((opt: string) => 'availability-day-' + opt)
    );
    let text = '';

    this.availabilityRanges.forEach((range: string, index: number) => {
      text += range;
      if (index < this.availabilityRanges.length - 1) {
        text += ',';
      }
    });

    if (text.length && this.availabilityDays.length) {
      text += '•';
    }

    this.availabilityDays.forEach((day: string, index: number) => {
      text += translations['availability-day-' + day];
      if (index < this.availabilityDays.length - 1) {
        text += ',';
      }
    });
    this.form.patchValue({
      availability: text,
    });
  }

  // Price
  onChangeSlider(event: any) {
    this.form.patchValue({
      price: event.value + '€ - ' + event.highValue + '€',
    });
  }

  /**
   * Get levels depending of current lesson selected
   */
  get currentLevels(): any {
    if (this.checkLessonObject) {
      return this.levels.filter(
        (level: any) => level.type === this.typeLessons.value.slice(0, -1)
      );
    } else {
      return [];
    }
  }

  /**
   * Check if  current lesson is an object
   */
  get checkLessonObject(): any {
    if (
      typeof this.form.value.subject === 'object' &&
      !Array.isArray(this.form.value.subject) &&
      this.form.value.subject !== null
    ) {
      return true;
    } else {
      if (this.form.value.levels) {
        this.form.patchValue({ levels: null });
      }
      return false;
    }
  }

  filterLangsMulti() {
    if (!this.languages) {
      return;
    }
    // get the search keyword
    let search = this.LangMultiFilterCtrl.value;
    if (!search) {
      this.filteredLangsMulti.next(this.languages.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLangsMulti.next(
      this.languages.filter(
        (lang: any) =>
          lang.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }
  filterCountry() {
    if (!this.countries) {
      return;
    }
    // get the search keyword
    let search = this.countryFilterCtrl.value;
    if (!search) {
      this.filteredCountryMulti.next(this.countries.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredCountryMulti.next(
      this.countries.filter(
        (country: any) =>
          country['name_' + this.general.translate.currentLang]
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }
  filterLesson() {
    if (!this.lessons) {
      return;
    }
    // get the search keyword
    let search = this.lessonFilterCtrl.value;
    if (!search) {
      this.filteredLessons.next(this.lessons.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLessons.next(
      this.lessons.filter(
        (lesson: any) =>
          lesson.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }

  /**
   * Download Teachers form api
   *
   */
  async filterTeachers(updatePage: any) {
    try {
      if (!this.form.value.subject) {
        this.teachers = [];
        this.teachersLength = 0;
        return;
      }

      if (updatePage) {
        this.actPage = 0;
      }
      if (!this.loading) {
        this.loadingTeachersSpinner = true;
      }

      const body: any = {};
      if (this.form.value.subject) {
        body['want_learn_id'] = this.form.value.subject.id;
        body['want_learn_type'] = this.form.value.subject.type;
      }
      if (this.form.value.search) {
        // Name Teacher
        body['want_learn_string'] = this.form.value.search;
      }
      if (this.form.value.price) {
        body['price_hour_min'] = this.sliderMinValue;
        body['price_hour_max'] = this.sliderHighValue;
      }
      if (this.form.value.country) {
        body['country_id'] = this.form.value.country;
      }

      if (this.form.value.nativeSpiker && this.form.value.languagesTeacher) {
        body['language_native'] = this.form.value.nativeSpiker;
      }

      if (this.form.value.availability) {
        body['availability'] = {
          days: this.availabilityDays,
          ranges: this.availabilityRanges,
        };
      }

      if (this.form.value.languagesTeacher) {
        body['language_id'] = this.form.value.languagesTeacher;
      }

      if (this.form.value.levels) {
        body['levels'] = this.form.value.levels;
      }

      body['order'] = this.order.value;

      const response = await this.general.httpPost(
        'teachers/paginate?page=' + (this.actPage + 1),
        body
      );

      this.teachers = response.data.items.map((item: any) => {
        // Order CustomLessons
        const arr = this.general.getArrayUniqueValues(item.custom_lessons, [
          'name',
          'lesson_id',
        ]);
        return {
          ...item,
          custom_lessons: arr,
          currentSubject: this.form.value?.subject?.name,
        };
      });

      this.teachersLength = response.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loadingTeachersSpinner = false;
    }
  }

  async onChangePage(event: any) {
    try {
      this.loading = true;
      this.actPage = event.pageIndex;

      await this.filterTeachers(false);
    } catch (error) {
      console.log(error);
    } finally {
      const element = document.getElementById('teachers-order');
      if (element) {
        element.scrollIntoView();
      }
      this.loading = false;
    }
  }
  /**
   * =================== END - Filter ===================
   */

  async openNewTab(id: any) {
    if (!this.user) {
      await this.general.navigate('auth/login');
      return;
    }

    // const params = {
    //   subject: this.form.value.subject.id,
    //   id: this.form.value.subject.id,
    //   type: this.typeLessons.value,
    //   is_custom: this.form.value.subject.type == 'custom_lesson',
    //   name: this.form.value.subject.name,
    // };
    
    this.general.openNewTab(`/search/teacher/${id}/${this.form.value.subject.id}`);
  }
  // this.form.value.subject.id

  async onSendMessage(teacher: any) {
    this.general.onSendMessage(teacher);
  }
}
